const WORD_PATTERN = /[^\s/?&=#]+/g;

/**
 * Trims `text` to at most `maxWords` words and appends an ellipsis when it was cut.
 *
 * A "word" is a run of characters delimited by whitespace or common URL separators
 * (`/`, `?`, `&`, `=`, `#`), so both prose and slash-separated URL paths truncate at
 * sensible boundaries. The original separators are kept in the returned text.
 *
 * @param {string} text
 * @param {number} [maxWords=10]
 * @returns {{ text: string, isTruncated: boolean }}
 */
export const truncateWords = (text, maxWords = 10) => {
  const source = text === null || text === undefined ? '' : String(text).trim();
  if (!source || maxWords <= 0) {
    return { text: source, isTruncated: false };
  }

  let wordCount = 0;
  let cutIndex = -1;
  for (const match of source.matchAll(WORD_PATTERN)) {
    wordCount += 1;
    if (wordCount === maxWords) {
      cutIndex = match.index + match[0].length;
    } else if (wordCount > maxWords) {
      return { text: `${source.slice(0, cutIndex)}...`, isTruncated: true };
    }
  }

  return { text: source, isTruncated: false };
};

export default truncateWords;
